/*
 * Copyright (c) 2022 biocrates life sciences ag, All rights reserved.
 */

import React from "react"

import Avatar from "react-avatar"
import {Link} from "react-router-dom"

import {Menu, MenuDivider, MenuItem} from "@blueprintjs/core"
import {Popover2} from "@blueprintjs/popover2"

import env from "../../context/Env"
import AboutDialog from "../dialog/AboutDialog"

export interface AvatarMenuSettings {
    isSetting?: boolean
    isAccountWindowOpen?: boolean
}

export interface AvatarMenuProps {
    fullName: string
    email: string
    settings: AvatarMenuSettings
    logout?: Function
}

const AvatarMenu: React.FC<AvatarMenuProps> = ({
    fullName,
    email,
    logout,
    settings,
}) => {
    const userAccountUrl = env("USER_ACCOUNT_URL")
    const userManualUrl = env("USER_MANUAL_URL")
    return (
        <div data-testid="avatar">
            <Popover2
                content={
                    <Menu>
                        <MenuItem
                            text="Signed in as"
                            style={{pointerEvents: "none"}}
                        />
                        <MenuItem
                            text={email}
                            style={{pointerEvents: "none"}}
                        />
                        <MenuDivider />
                        {settings.isAccountWindowOpen && (
                            <a
                                className="MenuLink"
                                href={userAccountUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <MenuItem icon="person" text="Account" />
                            </a>
                        )}
                        {!settings.isAccountWindowOpen && (
                            <Link className="MenuLink" to="/me">
                                <MenuItem icon="person" text="Account" />
                            </Link>
                        )}

                        {settings.isSetting && (
                            <Link to="/settings" className="MenuLink">
                                <MenuItem icon="settings" text="Settings" />
                            </Link>
                        )}
                        {userManualUrl !== "null" && (
                            <a
                                className="MenuLink"
                                href={userManualUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <MenuItem icon="manual" text="User Manual" />
                            </a>
                        )}
                        <AboutDialog />
                        {logout && (
                            <MenuItem
                                className="MenuLink"
                                icon="log-out"
                                text="Logout"
                                onClick={() => logout()}
                            />
                        )}
                        {!logout && (
                            <Link className="MenuLink" to="/logout">
                                <MenuItem icon="log-out" text="Logout" />
                            </Link>
                        )}
                    </Menu>
                }
                placement="auto-end"
            >
                <Avatar
                    size="35"
                    color="#8d2f28"
                    name={fullName}
                    style={{cursor: "pointer"}}
                    title="biocrates account"
                    alt="biocrates account"
                    round
                />
            </Popover2>
        </div>
    )
}

export default AvatarMenu
